// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1yuWF","left":"StickyBox_left__1HVSU","right":"StickyBox_right__3fFvl"};